import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from 'src/app/core/store/store';
import { PlayerUtilityService } from 'src/app/modules/player/services/player-utility.service';
import { Note } from 'src/app/shared/models/note.model';
import { EventsService } from 'src/app/shared/services/events.service';

@Component({
  selector: 'app-note-item',
  templateUrl: './note-item.component.html',
  styleUrls: ['./note-item.component.css']
})
export class NoteItemComponent implements OnInit {
  @Input() note: Note;
  @Output() remove: EventEmitter<string> = new EventEmitter<string>();
  @Output() edit: EventEmitter<Note> = new EventEmitter<Note>();
  truncate: boolean = true;
  showToggle: boolean = true;
  user: any;
  activation: any;
  currentUserCourse: any;
  constructor(private playerUtilityService:PlayerUtilityService, private eventsService: EventsService, private store: Store) {

  }

  ngOnInit() {
    if (this.note) {
      this.showToggle = this.note.description.length > 30;
      this.note.truncatedText = this.note.description.substring(0, 29);
    }
    this.store.select('user').subscribe((user: any) => {
      this.user = user;
    });
    this.store.select('activation').subscribe((activation: any) => {
      if(activation && activation[0]) {
        this.activation = activation[0];
      }
    });
    this.store.select('currentUserCourse').subscribe((data: any) => {
      if(data) {
        this.currentUserCourse = data;
      }
    });
  }

  onEdit() {
    this.edit.emit(this.note)
  }
  onRemove() {
    this.remove.emit(this.note._id);
  }

  jumpToTime(recordedTime){
    this.playerUtilityService.setSeekToTime =recordedTime ;
    this.playerUtilityService.setvideoNotes = this.note;
    // capture event
    try {   
      if(this.user && this.activation && this.currentUserCourse && this.note){
        let eventData = { user: this.user, activationData: this.activation, course: this.currentUserCourse, nugget: this.note}
        this.eventsService.viewNotesPlayerEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }

}
